export default __webpack_public_path__ + "static/media/Head_5_Ear_2_C5.d1f43e91.svg";